import React from 'react';

interface BookingTabsProps {
  activeTab: 'upcoming' | 'past';
  onTabChange: (tab: 'upcoming' | 'past') => void;
}

const BookingTabs: React.FC<BookingTabsProps> = ({ activeTab, onTabChange }) => {
  const tabClass = (tab: 'upcoming' | 'past') =>
    `px-4 py-1.5 sm:px-5 sm:py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
      activeTab === tab
        ? 'bg-purple-400 text-white'
        : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
    }`;

  return (
    <div className="flex space-x-1 bg-gray-100 p-1 rounded-xl inline-flex">
      <button
        onClick={() => onTabChange('upcoming')}
        className={tabClass('upcoming')}
        aria-current={activeTab === 'upcoming' ? 'page' : undefined}
      >
        Upcoming
      </button>
      <button
        onClick={() => onTabChange('past')}
        className={tabClass('past')}
        aria-current={activeTab === 'past' ? 'page' : undefined}
      >
        Past
      </button>
    </div>
  );
};

export default BookingTabs;
